import { render, staticRenderFns } from "./off-task.vue?vue&type=template&id=4db195f8&scoped=true&"
import script from "./off-task.vue?vue&type=script&lang=js&"
export * from "./off-task.vue?vue&type=script&lang=js&"
import style0 from "./off-task.vue?vue&type=style&index=0&id=4db195f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db195f8",
  null
  
)

export default component.exports